import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { NotasDefensaExDTO } from '../../../../core/models/titulacion/notasDefensaEx-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlTitulacion;

@Injectable()
export class NotasDefensaExService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getNotasDefensaExService() {
        return this.http.get<BodyListResponse<NotasDefensaExDTO>>(
            API_URL + '/api/v1/notasDefensaEx/todos'
        );
    }

    guardarNotasDefensaExService(notasDefensaExDTO: NotasDefensaExDTO) {
        return this.http.post(API_URL + '/api/v1/notasDefensaEx', notasDefensaExDTO);
    }

    getNotasDefensaExPorCodigoNotaExService(codigoNotaEx: string) {
        return this.http.get<BodyResponse<NotasDefensaExDTO>>(
            API_URL + '/api/v1/notasDefensaEx/' + codigoNotaEx
        );
    }
}
